module.exports = __webpack_public_path__ + "static/media/juno.f810ca14.svg";